import React, { createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import "./loading.scss";

const LoadingContext = createContext(null);

export function LoadingProvider({ children }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const showLoading = () => {
    setLoading(true);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  return (
    <LoadingContext.Provider
      value={{
        loading,
        showLoading,
        hideLoading,
      }}
    >
      {children}

      {loading && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-white px-5 backdrop-blur-md">
          <div className="kyc-surface flex w-full max-w-xs flex-col items-center rounded-2xl bg-white px-6 py-8">
            {/* Loading Icon */}
            <div className="relative flex h-16 w-16 items-center justify-center">
              <div className="absolute inset-0 animate-spin rounded-full border border-teal-100 border-t-teal-700" />

              <div className="absolute inset-2 rounded-full border border-slate-100" />

              <div className="h-2 w-2 animate-pulse rounded-full bg-teal-700" />
            </div>

            {/* Text */}
            <div className="mt-6 text-center">
              {/* <p className="text-[11px] font-medium tracking-[0.35em] text-stone-900">
                PROCESSING
              </p> */}

              <p className="mt-2 text-[11px] font-medium tracking-wide text-slate-500">
                {t("kyc.portal.pleaseWait")}
              </p>
            </div>

            {/* Progress */}
            <div className="mt-5 h-px w-32 overflow-hidden bg-slate-200">
              <div className="h-full w-1/2 animate-[loading_1.4s_ease-in-out_infinite] bg-teal-700" />
            </div>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  return useContext(LoadingContext);
}
